<template>
  <div
    class="base-checkbox"
    @click="onClick"
  >
    <div class="base-checkbox__icon">
      <div
        v-show="!value"
        class="base-checkbox__empty"
      >
        <div class="base-checkbox__empty-icon" />
      </div>
      <font-awesome-icon
        v-show="value"
        icon="check-square"
      />
    </div>
    <p class="base-checkbox__label">
      {{ label }}
    </p>
  </div>
</template>

<script>
export default {
    name: 'BaseSelect',
    props: {
        value: {
            type: [String, Boolean],
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hideStyle() {
            return {
                position: 'absolute',
                left: '-9999px',
            };
        },
    },
    methods: {
        onClick() {
            if (this.disabled) {
                return;
            }

            this.$emit('input', !this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.base-checkbox {
    cursor: pointer;
    display: inline-block;
    align-items: center;
    user-select: none;

    &:not(:last-child) {
        margin-bottom: 10px;
    }

    &__empty {
        display: inline-block;
        // padding-top: 1.5px;
        vertical-align: -0.095em;
    }

    &__empty-icon {
        width: 12.25px;
        height: 12.25px;
        border: 1.5px solid $brand;
        border-radius: 2px;
    }

    &__icon {
        width: 12.5px;
        display: inline-block;
        color: $brand;
        margin-right: 5px;
    }

    p {
        display: inline-block;
    }
}
</style>
